module.exports = "/_next/static/images/a83dda2b50e056438ba05d02c51e5e65-money-box-icon.svg";